import { Col, Row } from "antd";
import React from "react";
import CustomTag, { CustomTagProps } from "./CustomTag";

interface TagAndTextObject{
    label: string;
    tag?: string;
    customTag? : CustomTagProps;
}

interface TagAndTextProps{
    items: TagAndTextObject[];
}

const TagAndText : React.FC<TagAndTextProps> = ({ items }) => {

    const textStyle = {
        color: '#000000',
        fontWeight: 'bold'
    }
    
    const tagStyle = {
        border: '2px solid black', 
        fontFamily:'monospace',
        borderRadius:'36px',
        paddingRight: '8px',
        paddingLeft: '8px',
        height:'22px',
    }

    return(
        <Row align='top' gutter={24} style={{ padding:'4px' }}>
            {
                items.map( (item) => (
                    <>
                        <Col>
                            <p style={textStyle}>{item.label}</p>
                        </Col>
                        {
                            item.tag &&                         
                                <Col>
                                    <Row style={tagStyle}><p style={textStyle}>{item.tag}</p></Row>
                                </Col>
                        }
                        {
                            item.customTag &&                         
                                <Col>
                                    <CustomTag label={item.customTag.label} icon={item.customTag.icon} color={item.customTag.color} />
                                </Col>
                        }

                    </>
                ))
            }
        </Row>
    )
}

export default TagAndText;